export enum UploadErrorType {
  ExceedsFileLimit = 'exceeds_file_limit',
}
